<template>
  <div>
    <h2>Rapport de préconisation </h2><br>
    <div v-for="(preconization,index) in preconizations">
      <h3 :class="{'mt-30':index != 0}">{{preconization.number}}. {{preconization.title}} </h3>
      <span class="ml-10 mt-10" v-if="preconization.description">{{preconization.description}}<br></span>
      <div v-for="action in preconization.actions">
        <h4 class="ml-20">{{action.number}} {{action.title}}</h4>
        <div class="ml-50 mt-10" v-if="action.description" v-html="getDescription(action.description)"></div>
        <h5 class="ml-50" v-if="action.deadline">Délai de réalisation : {{action.deadline}} </h5>
      </div>
    </div>
  </div>
</template>

<script>

  export default {

    props: ["preconizations"],
    data(){
      return{
      }
    },
    mounted:function(){
    },
    watch:{
    },
    computed:{
    },
    methods:{
      getDescription(description){
        description = description.replace(new RegExp("\n", 'g'), "<br>");
        return description;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// report_preconization.vue?747cd676